<template>
    <div class="card w-100">
        <div class="card-header">
            <div class="row justify-content-between">
                <div class="col-auto">
                    <h5>{{ hotel.title }} </h5>
                </div>
                <div class="col-auto">
                    <h5 v-if="passengersToRoom > 0" class="card-title">Select rooms for {{ passengersToRoom }} passengers</h5>
                    <font-awesome-icon v-if="isValid && passengersToRoom == 0" icon="check" class="fa-2x" />
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <app-room v-for="room in rooms" :ref="room.elementId" :key="room.elementId" :productId="hotel.productId" :room="room" 
                    :passengersToRoom="passengersToRoom"
                    @addRoom="addRoomHandler" @removeRoom="removeRoomHandler" @gradeSet="gradeSetHandler" @onValidate="validate">
                </app-room>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import appRoom from './Room.vue';

export default { 
    props: {
        hotel: {
            type: Object, 
            required: true,
        },
        totalPassengers: {
            type: Number,
            required: true
        }
    },
    data() { 
        return { 
            passengersToRoom: this.totalPassengers,
            isValid: true,
        }
    },
    computed: {
        roomedPassengers() { 
            return this.totalPassengers - this.passengersToRoom;
        },
        rooms() {
            // attempt to return just the suitable rooms for the passenger / hotel combination
            return this.hotel.rooms.filter((r) => { return r.min <= this.totalPassengers });
        }
    },
    methods: { 
        ...mapActions([ 'addHotelRoom', 'removeHotelRoom', 'setHotelGrade' ]),
        addRoomHandler(elementId, gradeId, numberOfPassengers) {
            this.passengersToRoom -= numberOfPassengers;
            this.addHotelRoom({
                productId: this.hotel.productId, 
                elementId, 
                gradeId, 
                numberOfPassengers
            });
        },
        removeRoomHandler(elementId, numberOfPassengers) {
            this.passengersToRoom += numberOfPassengers;
            this.removeHotelRoom({
                productId: this.hotel.productId, 
                elementId, 
                numberOfPassengers
            });
        },
        gradeSetHandler(elementId, gradeId) {
            this.setHotelGrade({ productId: this.hotel.productId, elementId: elementId, gradeId: gradeId });
        },
        validate() {
            // loop through all room refs and check they are not invalid
            this.isValid = true;
            for (let i = 0; i < this.rooms.length; i++) {
                let room = this.rooms[i];
                let roomRef = this.$refs[room.elementId][0];
                
                // touch the room ref
                roomRef.$v.$touch();
                if (roomRef.$v.$invalid) {
                    this.isValid = false;
                    break;
                }
            }

            this.$emit('onValidate');
        },
    },
    components: {
        appRoom
    },
    created() { 
        this.$store.state.rooming.rooms.filter((room) => {
            return room.productId = this.hotel.productId
        }).forEach((room) => { 
            this.passengersToRoom -= room.passengersInRoom.reduce((sum, cur) => { return sum + cur });
        })
    }
}
</script>